
import { Union } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { awaitPromise, startAsPromise } from "../../fable_modules/fable-library-js.5.3.0/Async.js";
import { singleton } from "../../fable_modules/fable-library-js.5.3.0/AsyncBuilder.js";

/**
 * Case is Completed (not Shared) to avoid clashing with the Shared namespace.
 */
export class NativeShareOutcome extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Completed", "Cancelled", "Failed", "Unsupported"];
    }
}

export function NativeShareOutcome_$reflection() {
    return union_type("Shared.ShareActions.NativeShareOutcome", [], NativeShareOutcome, () => [[], [], [], []]);
}

export class CopyOutcome extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Copied", "CopyFailed"];
    }
}

export function CopyOutcome_$reflection() {
    return union_type("Shared.ShareActions.CopyOutcome", [], CopyOutcome, () => [[], []]);
}

/**
 * navigator.share bound to navigator, or None when absent. Read at click time only.
 */
export function browserShare() {
    return typeof navigator !== 'undefined' && typeof navigator.share === 'function' ? navigator.share.bind(navigator) : undefined;
}

/**
 * navigator.clipboard.writeText bound to the clipboard, or None when absent. Read at click time only.
 */
export function browserWriteText() {
    return typeof navigator !== 'undefined' && navigator.clipboard && typeof navigator.clipboard.writeText === 'function' ? navigator.clipboard.writeText.bind(navigator.clipboard) : undefined;
}

export function currentOrigin() {
    return window.location.origin;
}

/**
 * Tailwind `md` and up: the fallback menu is a dropdown rather than a sheet.
 */
export function isDesktopViewport() {
    return window.matchMedia('(min-width: 768px)').matches;
}

/**
 * AbortError = the user dismissed the OS sheet, so Cancelled; any other failure is Failed (open the fallback).
 */
export function tryNativeShare(share, payload) {
    if (share != null) {
        const share_1 = share;
        return startAsPromise(singleton.Delay(() => singleton.TryWith(singleton.Delay(() => {
            const data = {
                title: payload.Title,
                text: payload.Text,
                url: payload.Url,
            };
            return singleton.Bind(awaitPromise(share_1(data)), () => singleton.Return(new NativeShareOutcome(0, [])));
        }), (_arg_1) => {
            const name = _arg_1.name;
            return singleton.Return((name === "AbortError") ? (new NativeShareOutcome(1, [])) : (new NativeShareOutcome(2, [])));
        })));
    }
    else {
        return startAsPromise(singleton.Delay(() => singleton.Return(new NativeShareOutcome(3, []))));
    }
}

export function copyLink(writeText, url) {
    if (writeText != null) {
        const writeText_1 = writeText;
        return startAsPromise(singleton.Delay(() => singleton.TryWith(singleton.Delay(() => singleton.Bind(awaitPromise(writeText_1(url)), () => singleton.Return(new CopyOutcome(0, [])))), (_arg_1) => singleton.Return(new CopyOutcome(1, [])))));
    }
    else {
        return startAsPromise(singleton.Delay(() => singleton.Return(new CopyOutcome(1, []))));
    }
}

//# sourceMappingURL=ShareActions.js.map
